module.exports = __webpack_public_path__ + "static/img/certificate09.7030dff7.jpeg";